import { ref, type Ref, type VNode } from 'vue';

export class Drawer {
  static readonly drawers: Ref<Map<number, Drawer>> = ref(new Map());

  static closeAll(): void {
    Drawer.drawers.value.clear();
  }

  constructor(public vnode?: VNode) {}

  private _onClose: (() => void)[] = [];

  onClose(cb: () => void): void {
    this._onClose.push(cb);
  }

  open(vnode?: VNode): void {
    if (vnode) {
      this.vnode = vnode;
    }
    if (!this.vnode) {
      throw new Error('Cannot open Drawer without VNode');
    }
    const index = Drawer.drawers.value.size;
    this.onClose(() => {
      Drawer.drawers.value.delete(index);
    });
    Drawer.drawers.value.set(index, this);
  }

  close(): void {
    this._onClose.forEach((cb) => cb());
  }
}
